/**
 * GraphQL may return user ids as number or string; compare like Flutter
 * `_sameBookingUserId` / booking detail parity.
 */
export function sameBookingUserId(a: unknown, b: unknown): boolean {
  if (a == null || b == null) return false;
  return String(a).trim() === String(b).trim();
}
